import { render } from "./OwnerApp.vue?vue&type=template&id=440edfb2"
const script = {}

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__